import { benchmarksEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiBenchmarkResultHandler } from "@/services/shared";
import type { ApiBenchmarkStatusEnvelopeType, BenchmarkStatusResponseType } from "@/types";
import { sanitizeErrorMessageHandler } from "@/utils/sanitize-error-message";

export const getBenchmarkStatusHandler = async (jobId: string): Promise<BenchmarkStatusResponseType> => {
    const response = await axiosClient.get<ApiBenchmarkStatusEnvelopeType>(benchmarksEndpoints.status(jobId));

    const { data } = response.data;

    return {
        completedAt: data.completed_at,
        currentStep: data.current_step,
        displayProgress: data.display_progress ?? data.progress,
        displayProgressIsEstimated: data.display_progress_is_estimated ?? false,
        errorMessage: data.error_message ? sanitizeErrorMessageHandler(data.error_message) : data.error_message,
        progress: data.progress,
        result: data.result ? transformApiBenchmarkResultHandler(data.result) : null,
        startedAt: data.started_at,
        status: data.status,
    };
};
